import { render } from "./CloudText.vue?vue&type=template&id=71985e79&scoped=true"
import script from "./CloudText.vue?vue&type=script&lang=js"
export * from "./CloudText.vue?vue&type=script&lang=js"

import "./CloudText.vue?vue&type=style&index=0&id=71985e79&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71985e79"]])

export default __exports__